export const PRIMARY_COLOR = "#376B7E";
export const SECONDARY_COLOR = "#5CCC9D";
export const BACKGROUND_COLOR = "#CDFCFF";
